import React from "react";

const CareTeamDetailsSection = () => null;

export default CareTeamDetailsSection;

